import React, { Component, Fragment } from "react";
import moment from "moment";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Creators as ReportsActions,
  Selectors as ReportsSelectors,
} from "store/ducks/reports";

import { Access } from "common";
import { Page, Breadcrumbs, Panel, Loading } from "components";
import { Filters } from "./components";

const INITIAL_STATE = {
  date_start: null,
  date_end: null,
  type: "points",
  date_formatted: "",
  stores_formatted: "Todas",
};

class RegisterRanking extends Component {
  state = {
    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Relatórios", to: "/reports" },
      { name: "Ranking de Pontos", to: "" },
    ],
    filter: {
      ...INITIAL_STATE,
      stores: Access.lockedStore() ? [Access.lockedStore(true)] : [],
    },
  };

  componentDidMount() {
    const { filter } = this.state;
    const { getReportPointsRankingRequest } = this.props;

    getReportPointsRankingRequest(filter);
  }

  componentDidUpdate(oldProps, oldState) {
    const { filter } = this.state;

    if (
      oldState.filter.date_start !== filter.date_start ||
      oldState.filter.date_end !== filter.date_end
    ) {
      const date_formatted = filter.date_start
        ? `${
            filter.date_start !== null
              ? moment(filter.date_start).format("DD/MM/YYYY")
              : ""
          } ${filter.date_end !== null ? "-" : ""} ${
            filter.date_end !== null
              ? moment(filter.date_end).format("DD/MM/YYYY")
              : ""
          }`
        : "";

      this.setState({ filter: { ...filter, date_formatted } });
    }

    if (oldState.filter.stores !== filter.stores) {
      const stores_formatted = filter.stores
        .map((store) => store.label)
        .join(", ");

      this.setState({ filter: { ...filter, stores_formatted } });
    }
  }

  handleChangeFilter = async (name, value) => {
    const { filter } = this.state;
    const { getReportPointsRankingRequest } = this.props;

    this.setState({ filter: { ...filter, [name]: value } }, () => {
      getReportPointsRankingRequest(this.state.filter);
    });
  };

  handleCleanFilter = async (e) => {
    e.preventDefault();

    const { getReportPointsRankingRequest } = this.props;

    const newState = {
      filter: {
        ...INITIAL_STATE,
        stores: Access.lockedStore() ? [Access.lockedStore(true)] : [],
      },
    };

    this.setState(newState, () => {
      getReportPointsRankingRequest(this.state.filter);
    });
  };

  handleExport = () => {
    const { filter } = this.state;
    const { exportReportPointsRankingRequest } = this.props;

    exportReportPointsRankingRequest(filter);
  };

  render() {
    const { breadcrumbs, filter } = this.state;
    const { reports } = this.props;

    return (
      <Page className="page-reports">
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <header className="page-reports-header">
          <Page.Title>Ranking de Pontos</Page.Title>

          <Filters
            data={filter}
            onChange={this.handleChangeFilter}
            onClean={this.handleCleanFilter}
          />
        </header>

        <Panel className="panel-list">
          {!reports.data.length && reports.loading ? (
            <Loading type="page" size="x-large" />
          ) : (
            <Fragment>
              {reports.loading && <Loading type="table" size="x-large" />}

              {filter.date_formatted !== "" && (
                <Panel.Title>
                  Período: <span>{filter.date_formatted}</span>
                </Panel.Title>
              )}

              {filter.stores_formatted !== "" && (
                <Panel.Title>
                  Lojas: <span>{filter.stores_formatted}</span>
                </Panel.Title>
              )}

              <h5>Ranking de Pontos</h5>

              <table className="contact-table table table-curved">
                <thead>
                  <tr>
                    <th className="subTitle-report">Pos.</th>
                    <th className="subTitle-report-register">
                      <select
                        value={filter.type}
                        onChange={(e) =>
                          this.handleChangeFilter("type", e.target.value)
                        }
                      >
                        <option value="points">Pontos Gerados</option>
                        <option value="vouchers">Vouchers Utilizados</option>
                        <option value="ticket">Ticket Médio</option>
                      </select>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {!!reports.data.length &&
                    reports.data.map((report, index) => (
                      <tr key={`${report.store_id}-${index}`}>
                        <td>
                          {report.position} - {report.store_name}
                        </td>
                        <td className="number-report">{report.amount}</td>
                      </tr>
                    ))}
                </tbody>
              </table>

              <button className="button-submit" onClick={this.handleExport}>
                Exportar Planilha
              </button>
            </Fragment>
          )}
        </Panel>
      </Page>
    );
  }
}

const mapState = (state) => ({
  reports: {
    ...state.reports.pointsRanking,
    data: ReportsSelectors.pointsRanking(state.reports.pointsRanking.data),
  },
});

const mapActions = (dispatch) => bindActionCreators(ReportsActions, dispatch);

export default connect(mapState, mapActions)(RegisterRanking);
